'use client';
import React from 'react';
import Debug from '@/components/debug';
import { ContentBlocksRenderer } from '@/components/contentBlocks/ContentBlocksRenderer';
import { MaterializedFrontpage } from '@/lib/sanity/queries';
import { PageHeader } from '@/components/layout/PageHeader';

export default function HomePage({
  frontpage,
}: {
  frontpage: MaterializedFrontpage;
}) {
  return (
    <>
      <PageHeader />
      <main className="-mt-2 [&>[data-type=ContentBlocksGrid]]:mt-5 [&>:not([data-type=ContentBlocksGrid])]:mt-20 [&>:not([data-type=ContentBlocksGrid])]:mb-20">
        <ContentBlocksRenderer blocks={frontpage.blocks} />

        <Debug data={frontpage} label="Frontpage" />
      </main>
    </>
  );
}
